export default __webpack_public_path__ + "static/media/blob6.4e634e50.svg";